import React, { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { Modal3 } from "../../../../../components/DIsplay/Modal/Modal3";
import TextInput from "../../../../../components/form/TextInput";
import Button1 from "../../../../../components/form/Button1";
import requestTicketMoreInfo from "../../../../../controllers/booking/Ticket/requestMoreInfo";

function ManageOrderMoreInfoTicketRequestModal({ modal, setModal, booking }) {
  const [requestedInfo, setRequestedInfo] = useState("");
  const [loading, setLoading] = useState(false);
  async function handleRequestInfo() {
    const reqBody = {
      ticketQueueId: booking?._id,
      requestedInfo,
    };
    setLoading(true);
    const res = await requestTicketMoreInfo(reqBody).finally(() =>
      setLoading(false)
    );

    if (res.return) {
      enqueueSnackbar("More info has has been requested.", {
        variant: "success",
      });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }
  return (
    <div>
      <Modal3
        open={modal?.moreInfo}
        setOpen={(modalState) => setModal({ ...modal, moreInfo: modalState })}
        title={"Request More Info"}
      >
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          {/* <h5>What's missing?</h5> */}
          <TextInput
            label="Remarks"
            multiline
            rows={5}
            placeholder={"e.g. Phone number is required"}
            value={requestedInfo || ""}
            onChange={(ev) => setRequestedInfo(ev.target.value)}
          />
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setModal({ ...modal, moreInfo: false })}
            >
              Cancel
            </Button1>
            <div>
              <Button1 onClick={() => handleRequestInfo()} loading={loading}>
                Request more info
              </Button1>
            </div>
          </div>
        </div>
      </Modal3>
    </div>
  );
}

export default ManageOrderMoreInfoTicketRequestModal;
